import * as React from "react";

function SvgPerson(props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) {
  return <svg viewBox="0 0 16 16" ref={svgRef} {...props}><path d="M3.9 8.782a5.914 5.914 0 008.2 0 8 8 0 013.9 6.87c0 .117 0 .233-.007.348H.007C0 15.885 0 15.769 0 15.652a8 8 0 013.9-6.87zm4.1.261a4.522 4.522 0 114.522-4.521A4.522 4.522 0 018 9.043z" fill="currentColor" /></svg>;
}

const ForwardRef = React.forwardRef(SvgPerson);
export default ForwardRef;